export enum PopoverPlacement {
  BottomEnd = 'bottom-end',
  BottomStart = 'bottom-start',
}
